import CreateBrik from 'components/Modal/CreateBrik';
import { store } from 'store/configureStore';
import * as appActions from 'actions/app/actionTypes';
import ListRecipes from 'components/Modal/AddRecipe/ListRecipe';
import ListExercises from 'components/Modal/AddExercise/ListExercises';
import CreateRecipe from 'components/Modal/AddRecipe/CreateRecipe';
import CreateExercise from 'components/Modal/AddExercise/CreateExercise';
import ShareBrik from 'components/Modal/ShareBrik';
import SupportEmail from 'components/Modal/SupportEmail';
import { Membership } from 'components/Modal/MembershipModal';
import ConfirmModal from 'components/Modal/ConfirmModal';

const AppHelper = {

  showConfirmModal: (
    { 
      title, 
      subtitle, 
      handleOk,
      handleClose
    }: { 
      title: string, 
      subtitle: string, 
      handleOk: (e: any) => void,
      handleClose: (e: any) => void,
    }) => {
    const view = (
      <ConfirmModal 
        title={title}
        subTitle={subtitle}
        handleOk={handleOk}
        handleClose={handleClose}
      />
    );
    store.dispatch(appActions.actions.showGlobalModal({ view }));
  },

  showMembership: (params?: any) => {
    const view = (
      <Membership 
        step={params?.step}
        user={params?.user}
      />
    );
    store.dispatch(appActions.actions.showGlobalModal({ view }));
  },

  showSupportEmail: (params?: any) => {
    const view = (
      <SupportEmail params={params} />
    );
    store.dispatch(appActions.actions.showGlobalModal({ view }));
  },

  showCreateBrik: (params?: any) => {
    const view = (
      <CreateBrik
        itemEdit={params?.itemEdit}
        isEdit={params?.isEdit}
        typeBrikGroup={params?.typeBrikGroup}
        isFromDetail={params?.isFromDetail}
      />
    );
    store.dispatch(appActions.actions.showGlobalModal({ view }));
  },

  showListRecipe: (params?: any) => {
    const view = (
      <ListRecipes
        contentId={params?.contentId ? params?.contentId : null}
        isReplace={params?.isReplace ? params?.isReplace : false}
        brikId={params?.brikId}
        sectionId={params?.sectionId}
        subId={params?.subId}
        lastContentOrder={params?.lastContentOrder}
      />
    );
    store.dispatch(appActions.actions.showGlobalModal({ view }));
  },

  showListExercises: (params?: any) => {
    const view = (
      <ListExercises
        contentId={params?.contentId ? params?.contentId : null}
        isReplace={params?.isReplace ? params?.isReplace : false}
        brikId={params?.brikId}
        sectionId={params?.sectionId}
        subId={params?.subId}
        lastContentOrder={params?.lastContentOrder}
      />
    );
    store.dispatch(appActions.actions.showGlobalModal({ view }));
  },

  showCreateRecipe: (params?: any) => {
    const view = (
      <CreateRecipe
        itemEdit={params?.itemEdit}
        isEdit={params?.isEdit}
        isCreate={params?.isCreate}
        brikId={params?.brikId}
        sectionId={params?.sectionId}
        subId={params?.subId}
        isDuplicate={params?.isDuplicate}
        lastContentOrder={params?.lastContentOrder}
      />
    );
    store.dispatch(appActions.actions.showGlobalModal({ view }));
  },

  showCreateExercise: (params?: any) => {
    const view = (
      <CreateExercise
        itemEdit={params?.itemEdit}
        isEdit={params?.isEdit}
        isCreate={params?.isCreate}
        brikId={params?.brikId}
        sectionId={params?.sectionId}
        subId={params?.subId}
        lastContentOrder={params?.lastContentOrder}
        isDuplicate={params?.isDuplicate}
      />
    );
    store.dispatch(appActions.actions.showGlobalModal({ view }));
  },

  showShareBrik: (params?: any) => {
    const view = <ShareBrik brikId={params?.brikId} name={params?.name} />;
    store.dispatch(appActions.actions.showGlobalModal({ view }));
  },

  hideGlobalModal: () => {
    store.dispatch(appActions.actions.hideGlobalModal());
  },
};

export default AppHelper;
